var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['block.solutionsFinder'] = (function () {
    'use strict';

    const CONFIG = {
        JOURNEY_SELECTOR: '.block-solutions-finder__journey',
        JOURNEY_ANIMATION: 'animate__fadeInUp',
        JOURNEY_STAGGER: 150
    };

    const initialize = (block) => {
        if (!block || !block.id) return;

        const journeys = block.querySelectorAll(CONFIG.JOURNEY_SELECTOR);
        if (journeys.length === 0) return;

        App.ZagScrollAnimate.initialize(`#${CSS.escape(block.id)}`, {
            targets: [
                {
                    selector: CONFIG.JOURNEY_SELECTOR,
                    type: CONFIG.JOURNEY_ANIMATION,
                    stagger: CONFIG.JOURNEY_STAGGER
                }
            ]
        });
    };

    return {
        initialize
    };

})();
